import { uploadToS3, UPLOAD_TO_S3 } from './uploadToS3';
import { uploadFile } from './helpers';
import { deleteObjectsInS3, DELETE_OBJECTS_IN_S3 } from './deleteObjectsInS3';
import { downloadFromS3, DOWNLOAD_FROM_S3 } from './downloadFromS3';
import {
    downloadMultipleFromS3,
    DOWNLOAD_MULTIPLE_FROM_S3,
} from './downloadMultipleFromS3';
import { listObjectsInS3, LIST_OBJECTS_IN_S3 } from './listObjectsInS3';

export const s3Queries = {
    downloadFromS3,
    downloadMultipleFromS3,
    listObjectsInS3,
};

export const s3Mutations = {
    deleteObjectsInS3,
    uploadToS3,
};

export const s3QueryStrings = {
    DELETE_OBJECTS_IN_S3,
    DOWNLOAD_FROM_S3,
    DOWNLOAD_MULTIPLE_FROM_S3,
    LIST_OBJECTS_IN_S3,
    UPLOAD_TO_S3,
};

export const s3Helpers = { uploadFile };
